<kl-form-container>
  <div id="filterSet" style="position: relative; display: flex">
    <div style="margin-left: 30px" *ngIf="mode === 'add'">
      <div class="btn-group" role="group" dropdown placement="bottom right">
        <button
          type="button"
          class="btn btn-greenish btn-sm"
          (click)="commitSave('SAVE')"
        >
          <i class="fal fa-save"></i>
          {{ "save" | translate }}
        </button>
        <div class="btn-group" role="group">
          <button
            dropdownToggle
            type="button"
            class="btn btn-greenish dropdown-toggle btn-sm"
          >
            <span class="caret"></span>
          </button>
          <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu-right"
            role="menu"
          >
            <li role="menuitem">
              <a class="dropdown-item" (click)="commitSave('SAVE_NEW')">
                {{ "save_and_new" | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div style="margin-left: 30px" *ngIf="mode === 'edit'">
      <div class="btn-group" role="group" dropdown placement="bottom right">
        <button
          type="button"
          class="btn btn-greenish btn-sm"
          (click)="commitSave('SAVE')"
        >
          <i class="fal fa-save"></i>
          {{ "edit" | translate }}
        </button>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <form #VatGroupsForm="ngForm" novalidate>
    <div class="col-md-12 col-sm-12 row">
      <div class="col-md-6 col-sm-12">
        <div class="form-group row">
          <div class="col-md-3 col-sm-12">
            <label for="VatGroupsCode"
              ><small
                >{{ "code" | translate }} <i class="text-danger">*</i></small
              ></label
            >
          </div>
          <div class="col-md-9 col-sm-12">
            <input
              type="text"
              class="form-control form-control-sm"
              #VatGroupsCode="ngModel"
              #focusElement
              name="VatGroupsCode"
              [disabled]="isReadOnly"
              [ngClass]="errorShow && VatGroupsCode.invalid ? 'errorInput' : ''"
              [(ngModel)]="entity.code"
              (ngModelChange)="formChange(true)"
              id="VatGroupsCode"
              maxlength="10"
              required
            />
            <div
              *ngIf="errorShow && VatGroupsCode.invalid"
              class="errorMessage"
            >
              {{ "important_area" | translate }}
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-3 col-sm-12">
            <label for="VatGroupsName"
              ><small
                >{{ "description" | translate }}
                <i class="text-danger">*</i></small
              ></label
            >
          </div>
          <div class="col-md-9 col-sm-12">
            <input
              type="text"
              class="form-control form-control-sm"
              name="VatGroupsName"
              #VatGroupsName="ngModel"
              [disabled]="isReadOnly"
              [ngClass]="errorShow && VatGroupsName.invalid ? 'errorInput' : ''"
              [(ngModel)]="entity.description"
              (ngModelChange)="formChange(true)"
              id="VatGroupsName"
              maxlength="50"
              required
            />
            <div
              *ngIf="errorShow && VatGroupsName.invalid"
              class="errorMessage"
            >
              {{ "important_area" | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</kl-form-container>
